var isBrowser = typeof window !== "undefined";
export var getData = function getData() {
  return isBrowser && window.localStorage.__fitplan__ ? JSON.parse(window.localStorage.__fitplan__) : {};
};
export var getItem = function getItem(key) {
  return getData()[key];
};
export var setData = function setData(dataObj) {
  return window.localStorage.__fitplan__ = JSON.stringify(Object.assign(Object.assign({}, getData()), dataObj));
};
export var logout = function logout() {
  clearData();
  return isLoggedIn();
};
export var getUser = function getUser() {
  return isBrowser && getItem("user");
};
export var getAccessToken = function getAccessToken() {
  return isBrowser && getItem("access_token");
};
export var isLoggedIn = function isLoggedIn() {
  return isBrowser && !!getItem("access_token");
};
export var clearData = function clearData() {
  return window.localStorage.removeItem('__fitplan__');
};